import { render } from "./archive.vue?vue&type=template&id=1b1c3e06&scoped=true"
import script from "./archive.vue?vue&type=script&lang=js"
export * from "./archive.vue?vue&type=script&lang=js"

import "./archive.vue?vue&type=style&index=0&id=1b1c3e06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1c3e06"]])

export default __exports__